import { Box, Button, InputField, Modal, Typography, getColor } from "fds";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  /** 열려있는 모달의 모드 */
  mode: "update" | "insert";
  /** 모달 제목 / 서브타이틀에 표시할 현재 부서명 */
  currentDeptName: string;
  /** InputField 초기값 */
  initialInputValue: string;
  onClose: () => void;
  /** 저장 버튼 클릭 시 호출 (name = InputField 에 입력된 값) */
  onSave: (name: string) => Promise<void>;
}

const DeptNameModal: React.FC<Props> = ({
  mode,
  currentDeptName,
  initialInputValue,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(initialInputValue);

  const isUpdate = mode === "update";

  return (
    <Modal
      width={490}
      title={isUpdate ? t("admin.dept.changeDeptName") : t("admin.dept.addSubDept")}
      subTitle={
        isUpdate
          ? t("admin.dept.changeSelectedDeptName", { dept: currentDeptName })
          : t("admin.dept.deptSubtitle", { dept: currentDeptName })
      }
      open
      onClose={onClose}
      footer={
        <Box justifyContent="flex-end">
          <Button
            label={t("admin.common.button.cancel")}
            type="secondary"
            btnStyle="fill"
            onClick={onClose}
          />
          <Button
            label={isUpdate ? t("admin.common.button.modify") : t("admin.common.button.add")}
            type="primary"
            btnStyle="fill"
            state={inputValue.trim() === "" ? "disable" : "default"}
            onClick={() => onSave(inputValue)}
          />
        </Box>
      }
      body={
        <Box direction="column">
          <Typography
            classes="mg mb-8"
            type="body4_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("admin.dept.deptName")}
          </Typography>
          <InputField
            value={inputValue}
            placeholder={t("admin.dept.insertDeptName")}
            width={432}
            maxLength={isUpdate ? 64 : undefined}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </Box>
      }
    />
  );
};

export default DeptNameModal;
